import React from "react";

const Step3 = ({ formData, handleChange, handleCheckboxChange }) => {
  const {
    configProducto,
    configCertificaciones = [],
    configModulos = [],
    configPrivacidadTerminos,
  } = formData;

  const certificaciones = [
    { id: "organica", label: "Orgánica" },
    { id: "comercioJusto", label: "Comercio Justo" },
    { id: "rainforest", label: "Rainforest Alliance" },
    { id: "otra", label: "Otra..." },
    { id: "ninguna", label: "Ninguna" },
  ];

  const modulos = [
    {
      id: "sic",
      title: "SIC",
      description:
        "Sistema Interno de Control para la gestión de fichas y certificaciones.",
      hasDemo: true,
    },
    {
      id: "acopio",
      title: "Acopio",
      description:
        "Registro de entregas, pagos, seguimiento a créditos y gestión de bodegas.",
    },
    {
      id: "eudr",
      title: "EUDR",
      tag: "CAFÉ Y CACAO",
      description:
        "Análisis de riesgos para cumplimiento del Reglamento Europeo de No-deforestación.",
    },
    {
      id: "calidad",
      title: "Calidad",
      tag: "CAFÉ",
      description: "Análisis físico y sensorial para café de especialidad.",
    },
  ];

  return (
    <>
      {/* SECCION 1: PRODUCTO */}
      <div className="mb-4">
        <h6
          className="fw-bold mb-3 d-flex align-items-center text-uppercase"
          style={{
            color: "#8c98a4",
            fontSize: "0.85rem",
            letterSpacing: "1px",
          }}
        >
          <i className="fa fa-leaf me-2" style={{ color: "#4a6502" }}></i>{" "}
          Producto <span className="text-danger ms-1">*</span>
        </h6>
        <div className="input-group m-b-15">
          <span className="input-group-text">
            <i className="fa fa-tag"></i>
          </span>
          <select
            className="form-select form-control form-control-md"
            name="configProducto"
            value={configProducto || ""}
            onChange={handleChange}
            required
          >
            <option value="">Selecciona un producto</option>
            <option value="cafe">Café</option>
            <option value="cacao">Cacao</option>
            <option value="otro">Otro</option>
          </select>
        </div>
      </div>

      {/* SECCION 2: CERTIFICACIONES */}
      <div className="mb-4">
        <h6
          className="fw-bold mb-1 mt-4 d-flex align-items-center text-uppercase"
          style={{
            color: "#8c98a4",
            fontSize: "0.85rem",
            letterSpacing: "1px",
          }}
        >
          <i
            className="fa fa-certificate me-2"
            style={{ color: "#4a6502" }}
          ></i>{" "}
          Certificaciones de la Organización
        </h6>
        <p className="text-muted mb-3" style={{ fontSize: "0.8rem" }}>
          Selecciona todas las que apliquen
        </p>

        <div className="d-flex flex-wrap" style={{ gap: "12px" }}>
          {certificaciones.map((cert) => (
            <label
              key={cert.id}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                padding: "16px 24px",
                backgroundColor: "#F8FAFC",
                border: "1px solid #ddd",
                borderRadius: "8px",
                cursor: "pointer",
                fontSize: "0.85rem",
                userSelect: "none",
                transition: "all 0.2s ease",
              }}
            >
              <input
                type="checkbox"
                checked={configCertificaciones.includes(cert.id)}
                onChange={() =>
                  handleCheckboxChange("configCertificaciones", cert.id)
                }
                style={{
                  width: "16px",
                  height: "16px",
                  margin: 0,
                  cursor: "pointer",
                  flexShrink: 0,
                  accentColor: "#526b08",
                }}
              />
              {cert.label}
            </label>
          ))}
        </div>
      </div>

      {/* SECCION 3: MÓDULOS */}
      <div className="mb-4">
        <h6
          className="fw-bold mb-3 mt-4 d-flex align-items-center text-uppercase"
          style={{
            color: "#8c98a4",
            fontSize: "0.85rem",
            letterSpacing: "1px",
          }}
        >
          <i
            className="fa fa-layer-group me-2"
            style={{ color: "#4a6502" }}
          ></i>{" "}
          Módulos que más les interesa utilizar{" "}
          <span className="text-danger ms-1">*</span>
        </h6>

        <div className="row g-3">
          {modulos.map((mod) => (
            <div key={mod.id} className="col-12 col-md-6">
              <div
                className="d-flex align-items-center"
                style={{
                  cursor: "pointer",
                  backgroundColor: "#fff",
                  border: configModulos.includes(mod.id)
                    ? "2px solid #526b08"
                    : "1px solid #e0e0e0",
                  borderRadius: "8px",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                  transition: "all 0.2s ease",
                  minHeight: "140px",
                  padding: "24px",
                  marginBottom: "20px",
                }}
                onClick={() => handleCheckboxChange("configModulos", mod.id)}
                onMouseEnter={(e) => {
                  if (!configModulos.includes(mod.id)) {
                    e.currentTarget.style.backgroundColor = "#F8FAFC";
                  }
                }}
                onMouseLeave={(e) => {
                  if (!configModulos.includes(mod.id)) {
                    e.currentTarget.style.backgroundColor = "#fff";
                  }
                }}
              >
                {/* COLUMNA 1: CHECKBOX */}
                <div
                  style={{
                    marginRight: "20px",
                    flexShrink: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <input
                    type="checkbox"
                    checked={configModulos.includes(mod.id)}
                    readOnly
                    style={{
                      cursor: "pointer",
                      width: "18px",
                      height: "18px",
                      margin: 0,
                      accentColor: "#526b08",
                      flexShrink: 0,
                    }}
                  />
                </div>

                {/* COLUMNA 2: CONTENIDO */}
                <div className="flex-grow-1">
                  <h6
                    className="fw-bold mb-1"
                    style={{ fontSize: "0.95rem", color: "#2c3e50", margin: 0 }}
                  >
                    {mod.title}
                  </h6>
                  {mod.tag && (
                    <small
                      style={{
                        fontSize: "0.7rem",
                        color: "#8c98a4",
                        display: "block",
                        marginBottom: "6px",
                      }}
                    >
                      {mod.tag}
                    </small>
                  )}
                  <p
                    style={{
                      fontSize: "0.8rem",
                      color: "#666",
                      margin: 0,
                      lineHeight: "1.4",
                    }}
                  >
                    {mod.description}
                  </p>
                </div>

                {/* COLUMNA 3: BOTÓN DEMO */}
                {mod.hasDemo && (
                  <div style={{ marginLeft: "16px", flexShrink: 0 }}>
                    <button
                      type="button"
                      className="btn btn-sm d-flex align-items-center"
                      style={{
                        borderRadius: "6px",
                        fontSize: "0.7rem",
                        backgroundColor: "#fff",
                        border: "1px solid #ddd",
                        color: "#333",
                        fontWeight: "600",
                        padding: "6px 8px",
                        whiteSpace: "nowrap",
                      }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      <i className="fa fa-play-circle me-1"></i> VER DEMO
                    </button>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* TERMINOS Y PRIVACIDAD */}
      <div className="mb-4 mt-5">
        <div
          className="card border-0"
          style={{
            borderRadius: "10px",
            padding: "20px",
            background: "#F8FAFC",
          }}
        >
          <div className="form-check">
            <input
              className="form-check-input"
              id="configPrivacidadTerminos"
              type="checkbox"
              name="configPrivacidadTerminos"
              checked={configPrivacidadTerminos || false}
              onChange={(e) =>
                handleChange({
                  target: {
                    name: "configPrivacidadTerminos",
                    value: e.target.checked,
                  },
                })
              }
              required
            />
            <label
              className="form-check-label ms-2"
              htmlFor="configPrivacidadTerminos"
              style={{ fontSize: "0.85rem" }}
            >
              He leído y acepto el{" "}
              <a
                href="#"
                className="fw-bold text-sirio text-decoration-underline"
                style={{
                  color: "#526b08",
                  fontWeight: "bold",
                  textDecoration: "underline",
                }}
              >
                Aviso de Privacidad
              </a>{" "}
              y los{" "}
              <a
                href="#"
                className="fw-bold text-sirio text-decoration-underline"
                style={{
                  color: "#526b08",
                  fontWeight: "bold",
                  textDecoration: "underline",
                }}
              >
                Términos y condiciones
              </a>{" "}
              de Sirio.
            </label>
          </div>
        </div>
      </div>

      {/* RECAPTCHA PLACEHOLDER */}
      <div className="d-flex mb-4 text-center justify-content-md-start justify-content-center">
        <div className="d-inline-block p-3 rounded bg-white shadow-xs">
          <div className="d-flex align-items-center flex-column">
            <span className="fw-bold" style={{ fontSize: "0.9rem" }}>
              No soy un robot
            </span>
            <img
              src="https://www.gstatic.com/recaptcha/api2/logo_48.png"
              alt="recaptcha"
              className="ms-5"
              style={{ width: "30px" }}
            />
          </div>
          <div className="text-start mt-1 ms-4">
            <small className="text-muted" style={{ fontSize: "0.6rem" }}>
              reCAPTCHA
            </small>
            <br />
            <small className="text-muted" style={{ fontSize: "0.6rem" }}>
              Privacidad - Términos
            </small>
          </div>
        </div>
      </div>
    </>
  );
};

export default Step3;
